import * as React from "react";
const SvgNotification24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "black",
        viewBox: "0 0 22 22"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M4.996 14.973 4.978 15h12.044l-.018-.027c-.473-.71-.754-1.61-.754-2.723v-5a5.25 5.25 0 1 0-10.5 0v5c0 1.113-.28 2.013-.754 2.723ZM21 17v-1l.001-1h.004c.001 0 .001 0 0 0h-.014l-.08-.005a3.61 3.61 0 0 1-1.338-.358 2.293 2.293 0 0 1-.905-.774c-.23-.345-.418-.85-.418-1.613v-5a7.25 7.25 0 0 0-14.5 0v5c0 .762-.188 1.268-.418 1.613a2.292 2.292 0 0 1-.904.774 3.612 3.612 0 0 1-1.42.363H.996 1v2h20Zm-8 1a2 2 0 0 1-4 0H7a4 4 0 0 0 8 0h-2Z",
      clipRule: "evenodd"
    })
  );
export default SvgNotification24Px;
